
import { Bill } from './types';

export const billsData: Bill[] = [
  {
    id: 'BILL-001',
    month: 'April 2023',
    amount: 124.50,
    dueDate: '2023-05-15',
    status: 'Unpaid',
    consumption: 450,
    meterReading: '34521'
  },
  {
    id: 'BILL-002',
    month: 'March 2023',
    amount: 118.75,
    dueDate: '2023-04-15',
    status: 'Paid',
    consumption: 430,
    meterReading: '34071'
  },
  {
    id: 'BILL-003',
    month: 'February 2023',
    amount: 131.20,
    dueDate: '2023-03-15',
    status: 'Paid',
    consumption: 475,
    meterReading: '33641'
  },
  {
    id: 'BILL-004',
    month: 'January 2023',
    amount: 142.35,
    dueDate: '2023-02-15',
    status: 'Paid',
    consumption: 510,
    meterReading: '33166'
  }
];
